import { PlaidItemAccountMapping } from '../generated/graphql';
import { createContext, useContext } from 'react';

interface PlaidItemsContextValues {
  plaidItems: PlaidItemAccountMapping[];
  setPlaidItems: (plaidItems: PlaidItemAccountMapping[]) => void;
}

export const PlaidItemsContext = createContext<PlaidItemsContextValues | null>(null);

export function usePlaidItemsContext() {
  const plaidItemsContext = useContext(PlaidItemsContext);

  if (!plaidItemsContext) {
    throw new Error('Please use this function within a PlaidItemsContext provider');
  }

  return plaidItemsContext;
}
